export default "__VITE_ASSET__50e22ee4__"